import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import {
  User,
  Activity,
  APIResponse,
  TicketCount,
  EditProfileData,
  MyErrorStateMatcher,
  regExps,
  errorMessages,
  EqualValidator
} from '../_shared';
import {
  UserService,
  LoadingService,
  AuthenticationService,
  ProfilePictureService
} from '../_shared/services';
import { Granule } from '../config';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: [
    './profile.component.css',
    '../../assets/css/core-navbar.css',
    './profile-mobile-responsive.css'
  ]
})
export class ProfileComponent implements OnInit {
  @ViewChild('changeprofpic') changeprofpic: any;
  private editProfileForm: FormGroup;
  private user: User;
  private updateUser: EditProfileData;
  private submitEdit: boolean = false;
  private oldPasswordRequired: boolean = false;
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;

  private result: APIResponse<any, any> = null;
  private globalErrorMessage: Object = null;
  private errorMatcher = new MyErrorStateMatcher();
  private errors = errorMessages;
  private color = ['success', 'danger', 'warning', 'info', ''];
  private activities: Array<Activity> = Array<Activity>();
  private activityColor: Array<number>;
  private ticketCount: TicketCount = null;

  constructor(
    private loadingService: LoadingService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private profilepictureService: ProfilePictureService,
    private granule: Granule,
    private fb: FormBuilder
  ) {}
  ngOnInit() {
    this.createForm();
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
      this.countTickets();
      this.load(false);
    });
    this.populateFormInfo();
    this.getActivities();
  }

  createForm() {
    // constructor + form Validator
    this.editProfileForm = this.fb.group(
      {
        fullnameControl: ['', <any>Validators.required],
        emailControl: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(regExps.email)
          ])
        ],
        phoneControl: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(regExps.phone)
          ])
        ],
        companyControl: [''],
        oldPasswordControl: [''],
        newPasswordControl: ['', Validators.pattern(regExps.password)],
        confirmPasswordControl: ['']
      },
      {
        validator: EqualValidator.Match(
          'newPasswordControl',
          'confirmPasswordControl'
        )
      }
    );
  }

  countTickets() {
    let user_role: string;
    if (this.user.current_role.role_name === 'Client') {
      user_role = 'Client';
    } else {
      user_role = 'Officer';
    }
    let payload = JSON.stringify({
      user_id: this.user._id,
      user_role: user_role
    });
    this.userService.getCountedTickets(payload).subscribe(res => {
      this.ticketCount = res.data;
    });
  }

  oldPasswordFocus() {
    if (
      this.editProfileForm.controls.oldPasswordControl.pristine ||
      this.editProfileForm.controls.oldPasswordControl.value === null ||
      this.editProfileForm.controls.oldPasswordControl.value === ''
    ) {
      this.editProfileForm.controls.oldPasswordControl.markAsTouched();
      this.editProfileForm.controls.confirmPasswordControl.markAsTouched();
      this.toggleOldPasswordInput(true);
      this.editProfileForm.controls.oldPasswordControl.setErrors({
        empty: true
      });
    }
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  getActivities() {
    this.userService
      .getCurrentUserActivities()
      .finally(() => {
        this.addActivityColor();
      })
      .subscribe(res => {
        this.activities = res.data;
        this.activities.reverse();
      });
  }

  addActivityColor() {
    let count: number;
    if (this.activities) {
      count = this.activities.length;
    } else {
      count = 1;
    }
    this.activityColor = new Array<number>(count);

    for (let i = 0; i < this.activityColor.length; i++) {
      this.activityColor[i] = this.random();
    }
  }

  random() {
    let res = Math.floor(Math.random() * 5);
    return res;
  }

  uploadPicture(event: any, input: any) {
    const file: FileList = event.target.files; // get files from change event in browse button
    this.profilepictureService.pictureValidation(file, this.user._id);
    this.changeprofpic.nativeElement.value = '';
  }

  populateFormInfo() {
    this.toggleOldPasswordInput(false);
    this.editProfileForm.reset({
      fullnameControl: this.user.fullname,
      emailControl: this.user.email,
      phoneControl: this.user.phone,
      companyControl: this.user.company_name
    });
    this.random();
  }

  /**
   * Change Old Password 'required' properties.
   * default value: false
   *
   */
  toggleOldPasswordInput(value: boolean) {
    this.oldPasswordRequired = value;
  }

  EditProfile() {
    const formModel = this.editProfileForm.value;

    this.load(true);
    this.updateUser = {
      user_id: this.user._id,
      profile_picture: this.user.profile_picture,
      username: this.user.username,
      fullname: formModel.fullnameControl,
      email: formModel.emailControl,
      phone: formModel.phoneControl,
      company_name: formModel.companyControl,
      old_password: formModel.oldPasswordControl,
      new_password: formModel.newPasswordControl,
      password_confirmation: formModel.confirmPasswordControl,
      account_status: this.user.account_status
    };

    this.userService.editprofile(this.updateUser).subscribe(
      res => {
        console.log('VALUE RECEIVED: ', res);
        this.result = res;
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {
        if (this.result.success === true) {
          // this.message = 'Successfully Update Profile';
          // $('#submitNotification').modal('show');
          // load data after updating
          this.authenticationService.load();
          this.populateFormInfo();
        } else {
          this.globalErrorMessage = this.result.errors;
          console.log(this.globalErrorMessage);
        }
        this.load(false);
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/profile/profile.component.ts